import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import SectionHeader from './SectionHeader';
import { brand } from '../../shared-theme/brand';

// Everything that isn't already covered by the Features walkthrough above,
// so the two sections don't repeat each other.
const pillars = [
  {
    title: 'Web chat and intake forms',
    description:
      'A chat on your site and dynamic intake forms catch the people who would rather type than call.',
  },
  {
    title: 'WhatsApp, Messenger, and Instagram',
    description:
      'Messages that land in your social inboxes get the same screening and the same follow-up as a phone call.',
  },
  {
    title: 'Transcripts in your CRM',
    description:
      'Every conversation is transcribed and scored, and the record lands in your case management system with the lead.',
  },
  {
    title: 'Built around your criteria',
    description:
      'Practice areas, intake questions, disqualifiers, and hours are set per firm. Change a rule and it is live the same day.',
  },
  {
    title: 'Setup done for you',
    description:
      'We build your qualification flows, connect your tools, and test every scenario before a real caller hears it.',
  },
  {
    title: 'A team that keeps tuning',
    description:
      'No dashboard to babysit. We review calls, adjust your flows, and keep a named contact on your account.',
  },
];

export default function PlatformGrid() {
  return (
    <Box
      id="platform"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <SectionHeader
          title="Every way a client reaches you, covered"
          subtitle="Phones are only part of it. OpenIntake handles the rest of your inbound too, and our team runs it for you."
        />

        <Box
          component="ul"
          sx={{
            listStyle: 'none',
            m: 0,
            p: 0,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
            columnGap: { sm: 5, md: 6 },
            rowGap: { xs: 4, md: 6 },
          }}
        >
          {pillars.map((pillar) => (
            <Box
              component="li"
              key={pillar.title}
              sx={{ borderTop: `1px solid ${brand.sand}`, pt: 3 }}
            >
              <Typography
                component="h3"
                sx={{
                  fontSize: '1.075rem',
                  fontWeight: 600,
                  letterSpacing: '-0.01em',
                  color: brand.brown,
                  mb: 1,
                }}
              >
                {pillar.title}
              </Typography>
              <Typography
                sx={{
                  color: brand.taupe,
                  lineHeight: 1.65,
                  fontSize: '0.95rem',
                }}
              >
                {pillar.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
